import assets from "app/assets";
import gsap from "gsap";
import { Container, DEG_TO_RAD, Sprite, TextStyle, Text } from "pixi.js";
export default class Btn extends Container {
  constructor(label, size, textColor, color, picto) {
    super();
    this.onDown = this.onDown.bind(this);
    this.onUp = this.onUp.bind(this);
    this.onOut = this.onOut.bind(this);
    this._label = label;
    this.btn = new Sprite('');
    if (picto == null) {
      this.btn = new Sprite(assets.textures.btn.texture);
    }
    if (color) {
      this.btn.tint = color;
    }
    this.btn.scale.set(.7);
    this.btn.anchor.set(.5, .5);
    this.btn.interactive = true;
    this.btn.buttonMode = true;
    this.btn.on('pointerdown', this.onDown);
    this.btn.on('pointerup', this.onUp);
    this.btn.on('pointerupoutside', this.onOut);
    this.addChild(this.btn);
    const textStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: size,
      align: "center",
      fill: textColor,
      dropShadow: true,
      dropShadowAlpha: 1,
      dropShadowAngle: DEG_TO_RAD * 90,
      dropShadowBlur: 4,
      dropShadowColor: '0x000000',
      dropShadowDistance: 6
    });
    this._text = new Text(label, textStyle);
    if (this._text.width > this.btn.width) {
      this._text.width = this.btn.width;
      this._text.scale.y = this._text.scale.x;
    }
    this._text.anchor.set(.5);
    this._text.y = -14;
    this.btn.addChild(this._text);
    if (picto) {
      this.pictoSprite = new Sprite(picto);
      this.pictoSprite.anchor.set(.5, .5);
      // sprite.x = (this._text.width + sprite.width) >> 1;
      this.pictoSprite.y = -15;
      this.btn.addChild(this.pictoSprite);
    }
  }
  onDown(event) {
    if (!this._down) {
      this._down = true;
      gsap.to(this.btn.scale, {
        duration: .2,
        x: .6,
        y: .6
      });
    }
  }
  onUp(event) {
    if (this._down) {
      gsap.to(this.btn.scale, {
        duration: .2,
        x: .7,
        y: .7
      });
      this._callBack && this._callBack();
    }
    this._down = false;
  }
  onOut(event) {
    this._down = false;
    gsap.to(this.btn.scale, {
      duration: .2,
      x: .7,
      y: .7
    });
  }
  set click(callBack) {
    this._callBack = callBack;
  }
  set text(val) {
    this._text.text = val;
  }
}
